import { SwedBankIntegrationStatus } from './types';

export const SWED_BANK_INTEGRATION_STATUS = (status: SwedBankIntegrationStatus): string => {
	switch (status) {
		case SwedBankIntegrationStatus.PROCESSED_STATUS:
			return 'Processed';
		case SwedBankIntegrationStatus.NO_INVOICE_STATUS:
			return 'Invoice not found';
		case SwedBankIntegrationStatus.TO_BE_MANUALLY_PROCESSED_STATUS:
			return 'To be Manually Processed';
		case SwedBankIntegrationStatus.SKIPPED_STATUS:
			return 'Skipped';
		default:
			return status;
	}
};
